import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import type { TaskContragentFormInterface } from '@zaoblako/shared/modules/task/dtos/contragent/task-contragent-form.dto';

@Pipe({
  name: 'parseErrorForm',
  standalone: true
})
export class ParseErrorFormPipe implements PipeTransform {
  public transform(error: ValidationErrorInterface<TaskContragentFormInterface>): string {
    if (!error) {
      return null;
    }
    if (typeof error === 'string') {
      return error;
    }

    return this.parser(error).join(', ');
  }

  private parser(error: any): string[] {
    return Object.keys(error).reduce<string[]>((result, key) => {
      if (Array.isArray(error[key])) {
        error[key].forEach((item) => {
          result = result.concat(this.parser(item));
        });
      } else if (['function', 'object'].includes(typeof error[key])) {
        result = result.concat(this.parser(error[key]));
      } else {
        result = result.concat(error[key]);
      }
      return result;
    }, []);
  }
}
